module.exports = __webpack_public_path__ + "static/media/cloud-upload-svgrepo-com.d7836571.svg";